import { toast } from "@altimateai/lego";

export const handleConnectionTestToast = (response?: { ok?: boolean, message?: string }) => {
  if (response?.ok) {
    toast({
      title: "Connection Test Successful",
    });
  } else {
    toast({
      variant: "destructive",
      title: "Connection Test Failed",
      description: response?.message || "Please check your connection details and try again.",
    });
  }
};
